import { CommonModule, registerLocaleData } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { NgbModule, NgbTypeaheadModule } from "@ng-bootstrap/ng-bootstrap";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { MaterialModule } from "../material.module";

import { FooterComponent } from "./footer/footer.component";
import { LoadingSpinnerModule } from "./spinner/loading-spinner.module";
import { MenubarComponent } from "./menubar/menubar.component";
import { ModalConfirmComponent } from "./modals/modal-confirm/modal-confirm.component";
import { ModalSuccessComponent } from "./modals/modal-success/modal-success.component";
import { ModalErrorComponent } from "./modals/modal-error/modal-error.component";
import { GeneralEmptyModalComponent } from "./modals/general-empty-modal/general-empty-modal.component";
import { AuthenticationService } from "../auth/services/authentication.service";
import { UserInputSearcherComponent } from "./user-input-searcher/user-input-searcher.component";
import { MsalModule } from "@azure/msal-angular";
import localEsMx from "@angular/common/locales/es-MX";
import { SkeletonComponent } from "./skeleton/skeleton.component";
import { AvatarComponent } from "./avatar/avatar.component";
import { NoDataMsgComponent } from "./no-data-msg/no-data-msg.component";
import { PluralizePipe } from "./pipes/pluralize.pipe";
import { CustomFileUploaderComponent } from "./custom-file-uploader/custom-file-uploader.component";
import { FileUploadModule } from "@iplab/ngx-file-upload";
import { SharedCardComponent } from "./shared-card/shared-card.component";
import { LocationSearchComponent } from "./location-search/location-search.component";
import { ImageListComponent } from "./image-list/image-list.component";
import { OffCanvasComponent } from "./off-canvas/off-canvas.component";
import { Dc3FiltersComponent } from "./components/filters/dc3-filters/dc3-filters.component";
import { DetailsCardComponent } from "./details-card/details-card.component";

registerLocaleData(localEsMx);

@NgModule({
  declarations: [
    FooterComponent,
    MenubarComponent,
    ModalConfirmComponent,
    ModalSuccessComponent,
    ModalErrorComponent,
    GeneralEmptyModalComponent,
    AvatarComponent,
    UserInputSearcherComponent,
    SkeletonComponent,
    NoDataMsgComponent,
    PluralizePipe,
    CustomFileUploaderComponent,
    SharedCardComponent,
    LocationSearchComponent,
    ImageListComponent,
    OffCanvasComponent,
    Dc3FiltersComponent,
    DetailsCardComponent,
  ],
  imports: [
    NgbModule,
    CommonModule,
    FontAwesomeModule,
    LoadingSpinnerModule,
    MaterialModule,
    NgbTypeaheadModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MsalModule,
    FileUploadModule,
  ],
  providers: [AuthenticationService],
  exports: [
    AvatarComponent,
    FooterComponent,
    GeneralEmptyModalComponent,
    LoadingSpinnerModule,
    MenubarComponent,
    NoDataMsgComponent,
    PluralizePipe,
    SkeletonComponent,
    UserInputSearcherComponent,
    CustomFileUploaderComponent,
    SharedCardComponent,
    LocationSearchComponent,
    ImageListComponent,
    OffCanvasComponent,
    Dc3FiltersComponent,
    DetailsCardComponent,
  ],
})
export class SharedModule {}
